import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesScreenSchemesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-screen-schemes-edit',
	path: '/secure/admin/EditIssueTypeScreenScheme([!%]?[\\w]*).jspa',
};
